import { render } from "./SellStatus.vue?vue&type=template&id=5485a91a&scoped=true&ts=true"
import script from "./SellStatus.vue?vue&type=script&lang=ts"
export * from "./SellStatus.vue?vue&type=script&lang=ts"

import "./SellStatus.vue?vue&type=style&index=0&id=5485a91a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5485a91a"]])

export default __exports__